<p-toast />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.careerPath.title' | translate }}</p>
    
    <p-button
      *emPermission="Permission.CONFIG_BSA"
      class="p-button-success"
      icon="pi pi-plus"
      severity="success"
      (onClick)="onAdd()"></p-button>
  </div>
  <p-table
    [value]="careerPaths"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    paginatorPosition="bottom"
    paginatorAlignment="center"
    styleClass="w-full p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="practice" class="bg-white">
          {{ 'layout.configurations.careerPath.practice' | translate }} <p-sortIcon field="Practice" />
        </th>
        <th scope="col" pSortableColumn="name" class="bg-white">
          {{ 'layout.configurations.careerPath.name' | translate }} <p-sortIcon field="Career Path" />
        </th>
        <th scope="col" pSortableColumn="numberOfLevels" class="bg-white">
          {{ 'layout.configurations.careerPath.numberOfLevels' | translate }} <p-sortIcon field="numberOfLevels" />
        </th>
        <th *emPermission="Permission.CONFIG_BSA" scope="col" class="bg-white w-10rem pl-3">
          {{ 'layout.configurations.careerPath.actions' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-path>
      <tr>
        <td>{{ path.practice }}</td>
        <td>{{ path.name }}</td>
        <td>{{ path.numberOfLevels }}</td>
        <ng-container *emPermission="Permission.CONFIG_BSA">
          <td class="px-4 py-2 flex flex-row-reverse flex-wrap gap-2">
            <p-button icon="pi pi-pencil" [outlined]="true" class="mr-2" (onClick)="onEdit(path)"></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [outlined]="true"
              (onClick)="onDelete($event, path.id)"></p-button>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
